import React from 'react';
import { Flow } from 'flow-react';
import { observer } from 'mobx-react';
import { connect } from 'react-redux';
import { withRouter } from 'helpers/ModuleHelper';
import * as actions from 'store/actions';
import Card from 'react-bootstrap/Card';
import AppCard from 'components/Card/Card';
import * as ConfigTypes from 'config/ConfigTypes';
import { getMetaConfig } from "helpers/ConfigHelper";
import { parseStringField, checkGroupFields } from "helpers/FieldHelper";
import { sliceText } from "helpers/FieldHelper";
import { getImgUrl } from "helpers/ImageHelper";
import { pubPath } from 'helpers/AppHelper';
import './ObjectItem.scss';

const ObjectItem = observer(
    class ObjectItem extends React.Component {
        constructor(props) {
            super(props);
            this.state = {}
        }

        onObjectItem = () => {
            const { wpView, viewMode } = this.props.mediaObjects;
            this.props.updateMediaObjects({
                currentClip: this.props.object,
                wpView: ConfigTypes.DETAIL,
                viewMode: ConfigTypes.DETAIL,
                toTop: true,
                //lastView: wpView
                lastView: viewMode
            });
            this.props.router.navigate(`${ConfigTypes.CLIP_PATH}/${this.props.object.id}`);
        }

        showPortraitCard = (wpView) => {
            const imgUrl = getImgUrl({ stateCurrentClip: this.props.object });
            const showFields = getMetaConfig({ wpView, props: this.props, configName: ConfigTypes.OBJECT });
            return (
                <Card className="item-card">
                    <Card.Img variant="top" src={imgUrl} onClick={this.onObjectItem}
                        className="item-card-img" />
                    <Card.Body>
                        {showFields.map((el, i) => (
                            <div key={`itemObjectItemGridItem${i}`}
                                className={el[`${wpView}html`] ? 'item-card-title' : 'item-card-text'}>
                                {parseStringField(this.props.object.metadata.fields[el.field])}
                                {checkGroupFields({ isGroup: el[`${wpView}group`], el, element: this.props.object, wpView })}
                            </div>))}
                    </Card.Body>
                </Card>)
        }

        showGridObjectItem = (wpView) => {
            const imgUrl = getImgUrl({ stateCurrentClip: this.props.object });
            const showFields = getMetaConfig({ wpView, props: this.props, configName: ConfigTypes.OBJECT });
            return this.showPortraitCard(wpView);
        }

        showObjectItem = () => {
            const { wpView } = this.props.mediaObjects;
            if (wpView == ConfigTypes.WORK_GRID) {
                return this.showGridObjectItem(wpView);
            } else if (wpView == ConfigTypes.WORK_LIST) {
                const showFields = getMetaConfig({ viewMode: wpView, props: this.props, configName: ConfigTypes.OBJECT });
                const imgUrl = getImgUrl({ stateCurrentClip: this.props.object });
                return (
                    <li className="list-group-item item-list-item" onClick={this.onObjectItem}>
                        {/* <img className="img-responsive img-rounded item-img" src={imgUrl} alt="" /> */}
                        {showFields.map((el, i) => {
                            if (i == 0) return (<img key={`itemObjectItemListItem${i}`} className="img-responsive img-rounded item-img" src={imgUrl} alt="" />)
                            return (
                                <div key={`itemObjectItemListItem${i}`}
                                    className={el[`${wpView}html`] ? 'item-card-title' : 'item-card-text'}>
                                    {/* {this.props.object.metadata.fields[el.field] || ''} */}
                                    {parseStringField(this.props.object.metadata.fields[el.field])}
                                    {checkGroupFields({ isGroup: el[`${wpView}group`], el, element: this.props.object, wpView })}
                                </div>)
                        })}
                    </li>)
            }
        }

        getObjectItemClasses = (el) => {
            const { wpView } = this.props.mediaObjects;
            let classes = "item-card-text";
            if (el[`${wpView}html`]) classes = 'item-card-title';
            if (wpView == ConfigTypes.WORK_LIST) {
                classes = 'item-card-title-list item-card-item-list';
            }
            return classes;
        }

        showObjectItems = () => {
            const { wpView } = this.props.mediaObjects;
            let htmlClasses = "item-card-conten-grid";
            if (wpView == ConfigTypes.WORK_GRID) {
                return this.showGridObjectItem(wpView);
            } else if (wpView == ConfigTypes.WORK_LIST) {
                const showFields = getMetaConfig({ viewMode: wpView, props: this.props, configName: ConfigTypes.OBJECT });
                const imgUrl = getImgUrl({ stateCurrentClip: this.props.object });
                htmlClasses = "item-card-content-list";
                return (
                    <li className="list-group-item item-list-item" onClick={this.onObjectItem}>
                        <div className="objectitem-card-content-list">
                            {/* <div className="item-card-imgbox">
                                <img className="img-responsive img-rounded item-img" src={imgUrl} alt="" />
                            </div> */}
                            {showFields.map((el, i) => {
                                let dategroup = false;
                                if (el[`${wpView}type`] && (el[`${wpView}type`] == ConfigTypes.DATEGROUP)) dategroup = true;
                                if (i == 0) {
                                    return (
                                        <div className="item-card-imgbox" key={`itemObjectItemListItem${i}`}>
                                            <img className="img-responsive img-rounded item-img" src={imgUrl} alt="" />
                                        </div>
                                    )
                                }
                                return (
                                    <div key={`itemObjectItemListItem${i}`} className={this.getObjectItemClasses(el)}>
                                        {/* {this.props.object.metadata.fields[el.field] || ''} */}
                                        {!dategroup && sliceText(parseStringField(this.props.object.metadata.fields[el.field]), 40)}
                                        {checkGroupFields({ isGroup: el[`${wpView}group`], el, element: this.props.object, viewMode: wpView })}
                                    </div>)
                            })}
                        </div>
                    </li>)
            }
        }

        componentDidMount() { }

        render() {
            return this.showObjectItems();
        }
    }
);

const mapStateToProps = (state) => ({
    mediaObjects: state.media.mediaObjects,
    configObjects: state.config.configObjects
});

const mapDispatchToProps = (dispatch) => ({
    updateMediaObjects: (obj) => dispatch(actions.updateMediaObjects(obj))
});

export default Flow.injectFlow(connect(mapStateToProps, mapDispatchToProps)(withRouter(ObjectItem)));